import { cn } from "@lib/utils";
import { useRouter } from "next/router";

export default function FilterButton({
  isActive,
  className = "",
  onClick,
  children,
  customYPadding,
}: {
  isActive: boolean;
  className?: string;
  onClick: () => void;
  children: React.ReactNode;
  customYPadding?: boolean;
}) {
  const showFilters = useRouter().query.show_filters === "true";
  return (
    <button
      className={cn(
        "flex px-3 transition border rounded-md w-fit text-white",
        className,
        isActive ? "border-primary-color" : "border-white",
        customYPadding ? `py-0` : `py-1`,
        {
          "md:text-black": !showFilters,
        }
      )}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
